export default __webpack_public_path__ + "static/media/Homepage-packages-image-size-370_370-Sampoorna-MP-.85d394af.png";